// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z6qw","col":"styles_col__3F9-p","actions":"styles_actions__2G5hd","conflict":"styles_conflict__1sKPy"};